import api from "~services/axios";

export default {
  // 团队字典配置
  apiQueryTeam: params => api.get("/api/crmcustomer/queryteam", params),
  // 新增客户
  apiAddCustom: params => api.post("/api/crmcustomer/add", params),

  // 客户列表
  apiGetCustomList: params =>
    api.post("/api/crmcustomer/query", params, { timeout: 30000 }),

  // 客户详情
  apiGetCustomDetail: params => api.get("/api/crmcustomer/detail", { params }),
  // 客户详情-项目列表
  apiGetProjectDetail: params =>
    api.get("/api/crmcustomer/queryCustomerProject", { params }),

  // 删除客户
  apiDeleteCustom: params => api.post("/api/crmcustomer/delete", params),
  // 申请中客户删除
  apiDeleteingCustom: params =>
    api.post("/api/crmcustomer/deleteApply", params),

  // 修改客户信息，审核已通过的客户使用
  apiUpdateCustom: params => api.post("/api/crmcustomer/update", params),

  // 修正客户信息，审核未通过的客户使用
  apiCorrectionCustom: params =>
    api.post("/api/crmcustomer/updateApply", params),

  // 修改医生信息
  apiUpdateDoctor: params => api.post("/api/crmcustomer/update/doctor", params),

  // 获取客户详情内部项目列表
  apiGetProjectList: params =>
    api.get("/api/crmcustomer/queryCustomerProject", { params }),

  // 获取自己的客户申请列表
  // 未审核、审核通过、审核不通过所有状态的申请单就会被查询出来
  apiGetCustomerApplyList: params =>
    api.get("/api/crmcustomer/queryApply", { params }),

  // 普通销售修改自己提交的审核不通过的客户申请单（普通客户类型）
  apiUpdateCrmCustomer: params => api.post("/api/crmcustomer/add", params),

  // 普通销售修改自己提交的审核不通过的客户申请单（医生客户类型）
  apiUpdateDoctorCustomer: params =>
    api.post("/api/crmcustomer/add/doctor", params),

  // 更新对接客户的业务员
  apiUpdateCustomSalesman: params =>
    api.post("/api/crmcustomer/updateSalesman", params),

  // 客户联系人
  apiGetCustomContacts: params =>
    api.get("/api/crmcustomer/query/customer/convert", { params }),

  // 客户业务员
  apiGetCustomSalesman: params =>
    api.get("/api/crmcustomer/salesmanQuery", { params }),
  apiAddCustomSalesman: params =>
    api.post("/api/crmcustomer/addSalesman", params),
  apiDeleteCustomSalesman: params =>
    api.post("/api/crmcustomer/deleteSalesman", params),

  // 最终客户
  apiGetFinallyCustom: params =>
    api.get("/api/crmcustomer/queryTheFinalCustomer", { params }),
  apiAddFinallyCustom: params =>
    api.post("/api/crmcustomer/addTheFinalCustomer", params),
  apiEditFinallyCustom: params =>
    api.post("/api/crmcustomer/updateTheFinalCustomer", params),
  apiDeleteFinallyCustom: params =>
    api.post("/api/crmcustomer/delTheFinalCustomer", params),

  // 客户拜访记录
  apiGetCustomVisits: params =>
    api.get("/api/crmcustomer/query/customer/visit", { params }),

  // 导出客户列表
  apiExportCustom: (params, config) =>
    api.post("/api/crmcustomer/export", { params }, config),

  // 客户商机列表
  apiGetCustomBusi: params =>
    api.get("/api/crmcustomer/query/customer/business", { params }),

  // 客户合同列表
  apiGetCustomCompact: params =>
    api.get("/api/crmcustomer/query/customer/contract", { params }),

  // 医院等级
  apiGetHospitalLevel: params =>
    api.get("/api/common/query/category", { params }),

  // 添加联系人
  apiAddConvert: params => api.post("/api/crmcustomer/addConvert", params),

  // 修改联系人
  apiUpdateConvert: params =>
    api.post("/api/crmcustomer/updateConvert", params),

  // 删除联系人
  apiDeleteConvert: params =>
    api.post("/api/crmcustomer/deleteConvert", params),

  // 分配客户-查看客户获取医生列表
  apiGetDoctorList: params =>
    api.get("/api/crmcustomer/allocation/query", { params, timeout: 30000 }),

  // 分配客户保存
  apiSaveDoctorDistribute: params =>
    api.post("/api/crmcustomer/allocation/save", params),

  // 获取运营人员
  apiGetOperatorList: params =>
    api.get("/api/crmcustomer/query/operationuser", { params }),

  // 保存运营人员修改
  apiSaveOperatorChange: params =>
    api.post("/api/crmcustomer/updateoperation", params),

  // 客户档案列表
  apiGetCustomArchiveList: params =>
    api.get("/api/crmcustomer/query/customer/file", { params }),
  apiUploadFile: (params, config) =>
    api.post("/api/crmcustomer/upload/file", params, config),
  apiDeleteFile: params => api.post("/api/crmcustomer/deletefile", params),

  // 机构驳回客户列表
  apiGetRefusedCustomer: params =>
    api.get("/api/crmorganization/query", { params }),
  apiBindCode: params => api.post("/api/crmorganization/updateOrg", params),
  apiReplyAgain: params => api.post("/api/crmorganization/applyOrg", params),

  // 政府客户列表
  apiGetGovernmentData: params => api.get("/api/govInspect/query", { params }),
  apiDeleteGovernmentCus: params => api.post("/api/govInspect/delete", params),
  apiAddGovernmentCus: params => api.post("/api/govInspect/add", params),
  apiGetBusiLine: params => api.get("/api/govInspect/group", { params }),
  apiGetInvestigationPerson: params =>
    api.get("/api/govInspect/clues/query", { params }),
  apiGetGovernmentDetail: params =>
    api.get("/api/govInspect/detail", { params }),
  apiEditGovernmentCus: params => api.post("/api/govInspect/update", params),
  apiGetProjectData: params =>
    api.get("/api/govInspect/project/query", { params }),
  apiAddProject: params => api.post("/api/govInspect/project/add", params),
  apiDeleteProject: params =>
    api.post("/api/govInspect/project/delete", params),
  apiEditProject: params => api.post("/api/govInspect/project/update", params),
  apiDeleteProjectFollow: params =>
    api.post("/api/govInspect/project/record/delete", params),
  apiGetProFollowList: params =>
    api.get("/api/govInspect/project/record/query", { params }),
  apiAddProjectFollow: params =>
    api.post("/api/govInspect/project/record/add", params),
  apiEditProjectFollow: params =>
    api.post("/api/govInspect/project/record/update", params),

  // 全部医生列表
  apiGetDoctorData: params => api.get("/api/crmdoctor/query", { params }),
  // 客户新增判断客户保有量
  apiGetCustomerHold: params =>
    api.get("/api/crmcustomer/checkCustomerHolding", { params }),
  // 客户查重列表
  searchCustomerRepeat: params =>
    api.get("/api/crmcustomer/searchCustomerRepeat", { params }),
  // 客户类型下拉框获取接口 非医生
  apiGetCustomerTypeCategory: params =>
    api.get("/api/crmcustomer/queryCustomerTypeCategory", { params }),
  // 客户导入
  apiImportCustomer: (params, config) =>
    api.post('/api/crmcustomer/importCustomer', params, config),
  // 添加运营标签
  apiImportCustomer: params =>
  api.post('/api/crmMedicalCustomer/addLable', params),
  // 医生客户操作日志
  apiGetCustomerOperationLog: params =>
    api.get("/api/crmMedicalCustomer/query/doctor/operationLog", { params }),
};
